export default "__VITE_ASSET__BE4i_ysR__"